document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-highlight-select]');
  if (!select) return;
  const section = select.closest('[data-product-highlight]');
  const option = select.selectedOptions[0];
  const available = option.dataset.available === 'true';
  const id = section.querySelector('[data-highlight-id]');
  const price = section.querySelector('[data-highlight-price]');
  const compare = section.querySelector('[data-highlight-compare]');
  const title = section.querySelector('[data-highlight-title]');
  const button = section.querySelector('[name="add"]');
  if (id) id.value = option.value;
  if (price) price.textContent = option.dataset.price;
  if (title) title.textContent = option.textContent.trim();
  if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
  if (button) { button.disabled = !available; button.toggleAttribute('aria-disabled', !available); }
  const add = section.querySelector('[data-highlight-add]');
  const sold = section.querySelector('[data-highlight-sold]');
  if (add) add.hidden = !available;
  if (sold) sold.hidden = available;
});

document.addEventListener('click', async (event) => {
  const offerButton = event.target.closest('[data-highlight-discount]');
  if (!offerButton) return;

  event.preventDefault();
  if (offerButton.getAttribute('aria-busy') === 'true') return;

  const section = offerButton.closest('[data-product-highlight]');
  const status = section?.querySelector('[data-highlight-offer-status]');
  const buttonLabel = offerButton.querySelector('em');
  const discountCode = offerButton.dataset.discountCode?.trim();
  const defaultLabel = offerButton.dataset.applyLabel || buttonLabel?.textContent || 'Apply';

  if (!discountCode) return;

  offerButton.setAttribute('aria-busy', 'true');
  offerButton.classList.remove('is-applied', 'has-error');
  if (buttonLabel) buttonLabel.textContent = 'Applying…';

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ discount: discountCode }),
    });
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(result.description || result.message || 'Unable to apply discount');
    }

    offerButton.classList.add('is-applied');
    offerButton.setAttribute('aria-label', `Discount code ${discountCode} applied`);
    if (buttonLabel) buttonLabel.textContent = 'Applied';
    if (status) status.textContent = `Discount code ${discountCode} has been applied to your cart.`;
  } catch (error) {
    offerButton.classList.add('has-error');
    if (buttonLabel) buttonLabel.textContent = 'Try again';
    if (status) status.textContent = `Discount code ${discountCode} could not be applied. Please try again.`;

    window.setTimeout(() => {
      offerButton.classList.remove('has-error');
      if (buttonLabel) buttonLabel.textContent = defaultLabel;
    }, 3000);
  } finally {
    offerButton.removeAttribute('aria-busy');
  }
});
